import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/teacher/groups",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "get-students-by-group": ({ dispatch, state, rootState }, options) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-students-by-group?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "get-first-grade-groups": ({ dispatch, state }, options) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-first-grade-groups?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "save-first-grade-extra-assessments": ({ dispatch, state }, data) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/save-first-grade-extra-assessments`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
